<h2>Layout Components</h2>
<p class="demo-description">Demonstrates <code>upp-dropdown</code>, <code>upp-scrollable</code>, and <code>upp-visible-control</code>.</p>

<!-- Controls -->
<div class="demo-controls">
    <ion-button size="small" (click)="toggleDropdown()">Toggle Dropdown</ion-button>
    <ion-button size="small" (click)="cycleScrollDirection()">Scroll: {{ scrollDirection }}</ion-button>
</div>

<!-- upp-dropdown demo -->
<div class="demo-section">
    <h3>upp-dropdown</h3>
    <div style="position: relative; min-height: 200px;">
        <ion-button (click)="toggleDropdown()">
            <ion-icon name="ellipsis-vertical"></ion-icon>
            Options
        </ion-button>
        <upp-dropdown [expand]="dropdownExpanded" (Closed)="onDropdownClosed()">
            <upp-dropdown-title>Dropdown Menu</upp-dropdown-title>
            <upp-dropdown-content>
                <ion-list>
                    <ion-item button lines="none">
                        <ion-icon name="create-outline" slot="start"></ion-icon>
                        <ion-label>Edit</ion-label>
                    </ion-item>
                    <ion-item button lines="none">
                        <ion-icon name="copy-outline" slot="start"></ion-icon>
                        <ion-label>Duplicate</ion-label>
                    </ion-item>
                </ion-list>
            </upp-dropdown-content>
            <upp-dropdown-separate></upp-dropdown-separate>
            <upp-dropdown-content>
                <ion-list>
                    <ion-item button lines="none">
                        <ion-icon name="trash-outline" slot="start" color="danger"></ion-icon>
                        <ion-label color="danger">Delete</ion-label>
                    </ion-item>
                </ion-list>
            </upp-dropdown-content>
        </upp-dropdown>
    </div>
</div>

<!-- upp-scrollable demo -->
<div class="demo-section">
    <h3>upp-scrollable (scrollbar={{ scrollDirection }})</h3>
    <div style="height: 200px; border: 1px solid var(--ion-color-medium, #ccc); border-radius: 8px; overflow: hidden;">
        <upp-scrollable [scrollbar]="scrollDirection">
            <div style="width: 800px;">
                <ion-list>
                    <ion-item *ngFor="let item of scrollItems" lines="full">
                        <ion-label>{{ item }}</ion-label>
                    </ion-item>
                </ion-list>
            </div>
        </upp-scrollable>
    </div>
</div>

<!-- upp-visible-control demo -->
<div class="demo-section">
    <h3>upp-visible-control (status: {{ visibilityStatus }})</h3>
    <p>Scroll this box to toggle visibility detection:</p>
    <div style="height: 100px; overflow-y: auto; border: 1px solid var(--ion-color-medium, #ccc); border-radius: 8px;">
        <div style="height: 50px;"></div>
        <upp-visible-control mode="content" (visibilityChange)="onVisibilityChange($event)">
            <ion-card>
                <ion-card-content>
                    This content is inside a <code>upp-visible-control</code>. Visibility is tracked.
                </ion-card-content>
            </ion-card>
        </upp-visible-control>
        <div style="height: 200px;"></div>
    </div>
</div>
